import { Reveal } from "./motion";
import { OUTCOMES } from "../../lib/siteData";

export const Outcomes = () => {
  return (
    <section id="outcomes" data-testid="outcomes-section" className="relative bg-ink-surface py-28 md:py-40 border-y border-white/10">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <Reveal className="mb-16 md:mb-20 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="font-body text-xs font-bold uppercase tracking-[0.25em] text-brand">{OUTCOMES.overline}</span>
            <h2 className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl font-bold uppercase leading-[0.95] tracking-tighter">
              {OUTCOMES.title}
            </h2>
          </div>
          <p className="max-w-xs font-body text-sm font-light italic leading-relaxed text-neutral-500">
            {OUTCOMES.note}
          </p>
        </Reveal>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {OUTCOMES.items.map((item, i) => (
            <Reveal key={item.t} delay={(i % 3) * 0.08}>
              <div className="group h-full rounded-2xl border border-white/10 bg-ink p-8 transition-colors duration-500 hover:border-brand/50">
                <div className="flex items-baseline justify-between">
                  <h3 className="font-heading text-2xl font-medium uppercase tracking-tight text-white">{item.t}</h3>
                  <span className="font-heading text-sm text-brand opacity-0 transition-opacity duration-300 group-hover:opacity-100">→</span>
                </div>
                <p className="mt-4 font-body text-base font-light leading-relaxed text-neutral-400">{item.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
